import { EVALUATION_ROUNDS, type EvaluationRound } from "@/types/enums";

const ROUND_GUIDANCE_BY_ROUND: Partial<Record<EvaluationRound, string>> = {
  [EVALUATION_ROUNDS.CV_PROFILE]:
    "Use Pending while the profile is under review. Move to Passed, Failed, or On Hold once the round is decided.",
  [EVALUATION_ROUNDS.MCQ]:
    "Use Pending while the assessment is queued or awaiting review. Move to Passed, Failed, or On Hold after evaluation.",
  [EVALUATION_ROUNDS.OPEN_ENDED]:
    "Use Pending while answers are awaiting review. Move to Passed, Failed, or On Hold after evaluation.",
  [EVALUATION_ROUNDS.VOICE_INTERVIEW]:
    "Use Pending before the interview outcome is decided. Use Passed, Failed, or On Hold for the round result.",
  [EVALUATION_ROUNDS.CAMPUS_INTERVIEW]:
    "For interview rounds, use Passed, Failed, or On Hold. Use Pending only when the candidate is lined up for this round.",
  [EVALUATION_ROUNDS.OFFICE_TECHNICAL]:
    "For interview rounds, use Passed, Failed, or On Hold. Use Pending only when the candidate is lined up for this round.",
  [EVALUATION_ROUNDS.HR_FOUNDER]:
    "For the final round, use Offered after the candidate clears HR/Founder. Use Accepted and Joined only after the offer stage.",
};

export const getCandidateStatusHint = (round?: string | null): string => {
  if (!round) {
    return "Statuses are grouped by stage so admins can separate pipeline updates, round decisions, and final hiring outcomes.";
  }

  return (
    ROUND_GUIDANCE_BY_ROUND[round as EvaluationRound] ||
    "Choose the status that matches the candidate's current stage in the hiring flow."
  );
};
